import { dataProps, teamListProps } from './properties'

export const setTeamList = (state, payload) => {
    state.list = payload
}    

export const setTeamData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.team_list.length === 0) {
        state.props.team_list = [JSON.parse(JSON.stringify(teamListProps))]
    } else {
        if(payload.copy) {
            state.props.team_list.forEach(element => {
                element.id = 0                
            })
        }
    }

} 

export const addNewTeamListItemRow = state => {

    let key = 0
    state.props.team_list.push(JSON.parse(JSON.stringify(teamListProps)))

    state.props.team_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('team_name_'+(key-1)).focus()
    }, 300);

}

export const removeTeamListItemRow = (state, payload) => {

    let key = 0

    state.props.deleted_team_list_items.push(state.props[payload])

    state.props.team_list.splice(payload, 1)

    if(state.props.team_list.length === 0) {
        state.props.team_list = [JSON.parse(JSON.stringify(teamListProps))]
    }

    state.props.team_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetTeamData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/teamList/mutations.js